<template>
    <div class="m-form__section m-form__section--third" >
        <div class="m-portlet__body">
            <div class="form-group m-form__group row">
                <div class="col-lg-6">
                    <label for="">{{ labels.themeName | capitalize }} * : </label>
                    <select class="form-control m-choices theme-choices">
                        <option value=" " disabled selected>{{ labels['select_an_option'] }} </option>
                        <option v-for="theme in crudData.themes" :value="theme.theme_id" :selected="form.theme_id === theme.theme_id">{{ theme.name }}</option>
                    </select>
                </div>
                <div class="col-lg-6">
                    <label class="">{{ labels.segmentationName | capitalize }} * : </label>
                    <input type="text" class="form-control m-input" v-model="form.name">
                </div>
            </div>
            <div class="form-group m-form__group row"></div>
            <div class="form-group m-form__group row">
                <div class="col-lg-6">
                    <label for="">{{ labels.parentName | capitalize }} * : </label>
                    <select class="form-control m-choices parent-seg-choices"></select>
                </div>
                <label class="col-2 col-form-label">{{ labels.is_general_segmentation | capitalize }}</label>
                <div class="col-1">
                    <span class="m-switch m-switch--outline m-switch--icon m-switch--accent">
                        <label>
                            <input type="checkbox" checked="checked" name="" v-model="isGeneral" :disabled="disableGeneralSegmentation">
                            <span></span>
                        </label>
                    </span>
                </div>
                <div class="col-2">
                    <a @click="toggleProductLinkModal" data-v-adc1355a href="#" style="background: #fd397a;color:#ffff;" class="btn btn-elevate btn-icon-sm btn-pill" :class="{'disabled': !canQuickAddProducts }"><i class="fa fa-bolt"></i><span>&nbsp; {{ labels.quick_link_products | capitalize }}</span></a>
                </div>
            </div>
            <div class="form-group m-form__group row">
                <div class="col-lg-12">
                    <label for="" v-show="selectedProducts.length">{{ labels.selected_products }} : </label>
                    <ul style="padding:0;list-style: none;">
                        <li
                            style="margin: 2px; max-width: 500px; white-space: normal !important; text-align: left !important;"
                            class="btn btn-sm m-btn--pill m-btn--air btn-success"
                            v-for="(prod, index) in orderedProductList">
                            <a href="#" @click="removeProduct(index, prod.id)"><i class="la la-close"></i></a><span> | {{ prod.label }}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="form-group m-form__group row">
                <div class="col-lg-12" id="child_segmentation_products_select">
                    <label for="">{{ labels.products | capitalize }}</label>
                    <select class="form-control m-choices product-choices" multiple></select>
                </div>
            </div>
        </div>
        <div class="m-form__actions m-form__actions" style="margin-top:60px;">
            <div class="row">
                <div class="col-sm-1">
                    <button type="button" data-dismiss="modal" class="btn btn-secondary" @click="toggleCRUDMode(null)">{{ labels.cancel }}</button>
                </div>
                <div class="col-sm-2">
                    <button type="button" class="btn btn-primary" @click="handleSave" :disabled="!requiredFieldsCheck || updateInProgress">{{ labels.save | capitalize }}</button>
                </div>
                <div class="col-lg-9" style="text-align:right;">{{ labels.required_fields_info }}</div>
            </div>
        </div>

        <ProductLinkModal v-if="canQuickAddProducts && productLinkModal" :generalSegmentation="themeGeneralSegmentation" :formProducts="form.products" ref="productLinkModal"/>

    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import Choices from 'choices.js';
import Swal from 'sweetalert2';
import { HTTP } from '../../../assets/js/axiosConfig';
import { firestoreDB } from '../../../assets/js/firebase.js';

import Uuid from '../../../assets/js/mixins';
import algoliaProductsAction from '../../../assets/js/algoliaProductsMixin';

import ProductLinkModal from './ProductLinkModal';

const allChoices = {
  themeChoices: null,
  parentSegChoices: null,
  productChoices: null,
};

export default {
  mixins: [Uuid, algoliaProductsAction],
  components: {
    ProductLinkModal,
  },
  data() {
    return {
      form: {
        segmentation_id: null,
        theme_id: null,
        segmentation_parent: null,
        name: '',
        products: [],
      },
      isGeneral: false,
      segmentationMatches: [],
      requiredFields: ['theme_id', 'name', 'segmentation_parent'],
      updateInProgress: false,
      selectedProducts: [],
    };
  },
  watch: {
    'form.theme_id': function () {
      this.themeGeneralSegmentation;
    },
    segmentationProductsToLink(value) {
      if (value.length) {
        this.mergeProductArrays();
      }
    },
  },
  computed: {
    ...mapState({
      labels: (store) => store.labels,
      crudData: (store) => store.crudData.cruds,
      crudMode: (store) => store.crudData.crudMode,
      generalSegmentations: (store) => store.crudData.generalSegmentations,
      segmentationProductsToLink: (store) => store.crudData.segmentationProductsToLink,
      productLinkModal: (store) => store.crudData.productLinkModal,
    }),
    ...mapGetters([
      'allParentSegmentations',
    ]),
    disableGeneralSegmentation() {
      return !(this.themeGeneralSegmentation.length === 0 || this.isGeneralSegmentation(this.form.segmentation_id));
    },
    themeGeneralSegmentation() {
      return this.crudData.segmentations.filter((segmentation) => {
        if (segmentation.hasOwnProperty('segmentation_parent') && this.form.theme_id) {
          return segmentation.theme_id === this.form.theme_id && this.isGeneralSegmentation(segmentation.segmentation_id);
        }
        return false;
      });
    },
    canQuickAddProducts() {
      return this.themeGeneralSegmentation.length && !this.isGeneralSegmentation(this.form.segmentation_id);
    },
    requiredFieldsCheck() {
      let count = 0;
      this.requiredFields.forEach((field) => {
        this.form[field] ? count += 1 : null;
      });
      return count === this.requiredFields.length;
    },
    activeGeneralSegmentations() {
      const generals = [];
      this.generalSegmentations.forEach((segmentation) => {
        segmentation.general ? generals.push(segmentation.id) : null;
      });
      return generals;
    },
    orderedProductList() {
      return this.orderBy(this.selectedProducts);
    },
  },
  methods: {
    ...mapActions([
      'toggleCRUDMode',
      'setSegmentationProductsToLink',
      'toggleProductLinkModal',
    ]),
    initThemeChoices() {
      const my = this;
      allChoices.themeChoices = new Choices('.theme-choices', {
        searchChoices: true,
        shouldSort: false,
        callbackOnInit() {
          this.passedElement.element.addEventListener('addItem', (event) => {
            my.form.theme_id = event.detail.value;
            if (allChoices.parentSegChoices) {
              my.form.segmentation_parent = null;
              allChoices.parentSegChoices.clearStore();
              allChoices.parentSegChoices.setChoices(my.getParentSegChoices(), 'value', 'label', true);
            }
          });
        },
      });

      allChoices.parentSegChoices = new Choices('.parent-seg-choices', {
        shouldSort: false,
        callbackOnInit() {
          if (my.form.theme_id) {
            this.setChoices(my.getParentSegChoices(), 'value', 'label', false);
          }

          this.passedElement.element.addEventListener('addItem', (event) => {
            my.form.segmentation_parent = event.detail.value;
          });
        },
      });

      allChoices.productChoices = new Choices('.product-choices', {
        shouldSort: false,
        removeItems: true,
        removeItemButton: true,
        renderChoiceLimit: 100,
        renderSelectedChoices: false,
        placeholderValue: my.labels.type_to_search,
        callbackOnInit() {
          const that = this;
          if (my.form.products) {
            my.buildProductIdList(my.form.products, null, null, my.setProductChoices);
          }
          this.passedElement.element.addEventListener('search', (event) => {
            my.getAlgoliaProduct(null, null, null, my.setProductChoices, event.detail.value);
          });

          this.passedElement.element.addEventListener('addItem', (event) => {
            event.preventDefault();
            if (my.form.products.indexOf(event.detail.value) === -1) {
              my.form.products.push(event.detail.value);
            }
            if (!my.isExistingProduct(event.detail.value, my.selectedProducts, 'id')) {
              my.selectedProducts.push({ id: event.detail.value, label: event.detail.label });
            }
          });

          this.passedElement.element.addEventListener('removeItem', (event) => {
            const formIndex = my.form.products.indexOf(event.detail.value);
            if (formIndex !== -1) {
              my.form.products.splice(formIndex, 1);
            }
            my.deleteExistingProduct(event.detail.value);
          });
        },
      });
    },
    getParentSegChoices() {
      const choices = [{
        value: ' ',
        label: this.labels.select_an_option,
        selected: true,
        disabled: true,
      }];
      const isParentSeg = this.form.segmentation_parent ? this.parentSegmentationExists(this.form.segmentation_parent) : false;
      let formMatch = 0;
      this.allParentSegmentations.forEach((seg) => {
        if (this.form.theme_id && seg.theme_id === this.form.theme_id) {
          const selected = isParentSeg ? this.form.segmentation_parent === seg.segmentation_id : false;
          selected ? formMatch += 1 : null;
          choices.push({
            value: seg.segmentation_id,
            label: seg.name,
            selected,
          });
        }
      });
      !formMatch ? this.form.segmentation_parent = null : null;
      return choices;
    },
    parentSegmentationExists(id) {
      return this.allParentSegmentations.filter((seg) => seg.segmentation_id === id).length;
    },
    setProductChoices(data, dataKey, products) {
      const list = [];
      products.forEach((prod) => {
        const prodIndex = this.form.products.indexOf(prod.productId);
        const productLabel = `${prod.brandName || ''}, ${prod.collectionName || ''}, ${prod.name || ''}`;
        let checkedItems = [];
        if (allChoices.productChoices && allChoices.productChoices._currentState && allChoices.productChoices._currentState.items.length) {
          checkedItems = allChoices.productChoices._currentState.items.filter((currentItem) => currentItem.value === prod.productId);
        }
        if (!checkedItems.length && prodIndex === -1) {
          list.push({
            value: prod.productId,
            label: productLabel,
            selected: false, //
          });
        }
        if (prodIndex !== -1 && !this.isExistingProduct(prod.productId, this.selectedProducts, 'id')) {
          this.selectedProducts.push({ id: prod.productId, label: productLabel });
        }
      });
      allChoices.productChoices.setChoices(list, 'value', 'label', true);
      return list;
    },
    isExistingProduct(compareValue, arrayToCompare, compareKey, deleteEntry) {
      return arrayToCompare.filter((product) => (compareKey ? product[compareKey] === compareValue : product === compareValue)).length;
    },
    deleteExistingProduct(productId) {
      let index = 0;
      for (index; index < this.selectedProducts.length; index++) {
        if (this.selectedProducts[index].id === productId) {
          this.selectedProducts.splice(index, 1);
          break;
        }
      }
    },
    handleSave() {
      this.updateInProgress = true;
      this.triggerRequestInProgress();

      if (this.form.segmentation_id) {
        // PUT request
        HTTP.put(`api/segmentations/${this.form.segmentation_id}`, this.form)
          .then((response) => {
            // 1. Reset create view
            this.updateFirestore('segmentations');
            this.handleGeneralSegmentation();
          })
          .catch((err) => {
            console.log(err);
            const title = `${this.labels.error_updating} segmentation`;
            this.sweetAlert('error', title, 2000);
          });
      } else {
        this.form.segmentation_id = this.uuid();
        this.sendPostRequest('segmentations', this.form, this.handleGeneralSegmentation);
      }
    },
    closeAction() {
      this.toggleCRUDMode(null);
      this.sweetAlert('success', this.labels.saved, 2000);
    },
    getCurrentSegmentation() {
      return this.crudData.segmentations.filter((seg) => seg.segmentation_id === this.crudMode.segmentation_id)[0];
    },
    handleGeneralSegmentation() {
      if (this.canQuickAddProducts) {
        // Update general segmentation data
        this.updateGeneralSegmentation();
      } else {
        this.markSegmentationAsGeneral();
      }
      this.updateInProgress = false;
      this.toggleCRUDMode(null);
      this.sweetAlert('success', this.labels.saved, 2000);
    },
    markSegmentationAsGeneral() {
      const my = this;
      if (this.isGeneral || this.isGeneralSegmentation(this.form.segmentation_id)) {
        firestoreDB.collection(`${process.env.ENV_SHORTNAME}_generalSegmentations`).doc(my.form.segmentation_id).set({
          themeId: my.form.theme_id,
          generalSegmentation: my.isGeneral,
        })
          .then(() => {
            console.log('_generalSegmentations updated in Firestore :)');
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    isGeneralSegmentation(segmentationId) {
      this.form.segmentation_id === segmentationId ? this.isGeneral = this.activeGeneralSegmentations.indexOf(segmentationId) !== -1 : null;
      return this.activeGeneralSegmentations.indexOf(segmentationId) !== -1;
    },
    setFormData(original, targetObj) {
      let key;
      for (key in original) {
        if (targetObj.hasOwnProperty(key)) {
          if (key !== 'products') {
            this.$set(targetObj, key, original[key]);
          }
        }
      }
    },
    mergeProductArrays() {
      this.segmentationProductsToLink.forEach((prod) => {
        this.form.products.indexOf(prod.id) === -1 ? this.form.products.push(prod.id) : null;
        !this.isExistingProduct(prod.id, this.selectedProducts, 'id') ? this.selectedProducts.push({ id: prod.id, label: prod.label }) : null;
      });
      // Clear the list array in store
      this.$nextTick(function () {
        this.setSegmentationProductsToLink([]);
      });
    },
    updateGeneralSegmentation() {
      if (this.themeGeneralSegmentation.length) {
        const generalProducts = this.remainingGeneralProducts();
        if (generalProducts.length !== this.themeGeneralSegmentation[0].products.length) {
          const generalSegmentation = JSON.parse(JSON.stringify(this.themeGeneralSegmentation[0]));
          generalSegmentation.products = generalProducts;
          // On save selection we remove any of the selected products from the general-segmentation
          HTTP.put(`api/segmentations/${generalSegmentation.segmentation_id}`, generalSegmentation)
            .then((response) => {
              this.updateFirestore('segmentations');
            })
            .catch((err) => console.log(err));
        }
      }
    },
    remainingGeneralProducts() {
      return this.themeGeneralSegmentation[0].products.filter((product) => this.form.products.indexOf(product) === -1);
    },
    removeProduct(index, productId) {
      this.selectedProducts.splice(index, 1);
      const formIndex = this.form.products.indexOf(productId);
      formIndex !== -1 ? this.form.products.splice(formIndex, 1) : null;
    },
    orderBy(dataArray) {
      return dataArray.sort((a, b) => (a.label && b.label ? a.label.localeCompare(b.label, 'fr', { sensitivity: 'base' }) : 0));
    },
    triggerRequestInProgress() {
      Swal({
        title: this.labels.save_in_progress,
        showConfirmButton: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen() {
          Swal.showLoading();
        },
      });
    },
  },
  mounted() {
    if (this.crudMode && this.crudMode !== 'create') {
      this.form = JSON.parse(JSON.stringify(this.getCurrentSegmentation()));
    }
    this.$nextTick(function () {
      this.initThemeChoices();
    });
  },
  beforeDestroy() {
    this.setSegmentationProductsToLink([]);
  },
};
</script>

<style>
    .choices__list--multiple .choices__item {
        background-color: #1b7e9a;
    }

    #child_segmentation_products_select .choices__list.choices__list--multiple {
        display: none;
    }

    .product_bill {
        margin-bottom: 2px;
        width: 400px;
        text-align: left !important;
        border-radius: 60px;
        background-color: #1b7e9a;
        border-color: #1b7e9a;
        padding: .85rem 1.15rem;
        color: #ffff;
        box-shadow: 0px 5px 10px 2px rgba(27,126,154,0.19) !important;
        font-size: 1rem;
    }

    .choices__input.choices__input--cloned {
        width: 180px !important;
        border-bottom: none !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/CRUDs/Segmentations/ChildSegmentationForm.vue